<template>
  <Fragment>
    <Switcher
      name="interval-orgs"
      v-model="selectedInterval"
      leftValue="month"
      leftText="Monthly"
      rightValue="year"
      rightText="Yearly"
      save-text="Save 16%"
      style="margin-bottom: 1.5rem"
    />

    <div class="plan-sliders">
      <Slider
        v-model="profiles"
        :step="1"
        :min="1"
        :max="40"
        thumb-label="always"
        style="margin-bottom: 1.75rem; margin-top: 3.25rem"
      >
        <template #thumb-label="{ value }">
          {{ value }} profile{{ value === 1 ? '' : 's' }}
        </template>
      </Slider>
      <Slider
        v-model="members"
        :step="1"
        :min="1"
        :max="40"
        thumb-label="always"
        style="margin-bottom: 1rem"
      >
        <template #thumb-label="{ value }">
          {{ value }} member{{ value === 1 ? '' : 's' }}
        </template>
      </Slider>
    </div>

    <div class="plans">
      <OrgProPlusPlan
        :interval="selectedInterval"
        :profiles="profiles"
        :members="members"
        :blocks="planBlocks"
      >
        <template slot="actions">
          <Button
            href="https://app.campsite.bio/create-account?org=1"
            size="large"
            >Start Your Free Trial</Button
          >
        </template>
        <template slot="below-actions">
          10-day trial included •
          <InlineLink to="/demo">Request a demo</InlineLink>
        </template>
      </OrgProPlusPlan>
      <OrgProPlan
        :interval="selectedInterval"
        :profiles="profiles"
        :members="members"
        :blocks="planBlocks"
      >
        <template slot="actions">
          <Button
            href="https://app.campsite.bio/create-account?org=1"
            size="large"
            >Start Your Free Trial</Button
          >
        </template>
        <template slot="below-actions">
          10-day trial included •
          <InlineLink to="/demo">Request a demo</InlineLink>
        </template>
      </OrgProPlan>
    </div>
  </Fragment>
</template>

<script>
import {
  Button,
  InlineLink,
  Slider,
  VText,
  PersonIcon,
  LinkIcon,
} from '@campsite-bio/component-lib';
import { computed, ref } from '@nuxtjs/composition-api';

import Switcher from '@/components/switcher';
import OrgProPlan from './org-pro-plan';
import OrgProPlusPlan from './org-pro-plus-plan';
import { MEMBER_PRICES, PROFILE_PRICES } from './plans';

export default {
  components: {
    Switcher,
    Button,
    OrgProPlan,
    OrgProPlusPlan,
    InlineLink,
    Slider,
    VText,
  },

  setup() {
    const selectedInterval = ref('month');
    const profiles = ref(1);
    const members = ref(1);

    const planBlocks = computed(() => {
      const profilePrice = Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      }).format(PROFILE_PRICES[selectedInterval.value]);
      const memberPrice = Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      }).format(MEMBER_PRICES[selectedInterval.value]);

      return [
        {
          icon: LinkIcon,
          title: `${profilePrice} per additional profile / ${selectedInterval.value}`,
        },
        {
          icon: PersonIcon,
          title: `${memberPrice} per additional member / ${selectedInterval.value}`,
        },
      ];
    });

    return {
      selectedInterval,
      profiles,
      members,
      planBlocks,
    };
  },
};
</script>

<style lang="scss" scoped>
.plan-sliders {
  padding-left: 0.5rem;
  padding-right: 0.5rem;

  @media (min-width: 1244px) {
    padding-left: 0;
    padding-right: 0;
  }
}

.plans {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  margin: 1.5rem 0;
  text-align: left;
}
</style>
